import type {Product, ProductOwner} from 'services/metadata/types';

const formatOwner = ({name, code}: ProductOwner) =>
  [code, name].filter(Boolean).join(' ');

const getAllOwners = (
  products: Product[],
  productOwners: ProductOwner[],
): ProductOwner[] => [
  ...productOwners,
  ...products
    .filter(({owner}) => !productOwners.some(({code}) => code === owner))
    .map(({owner}) => ({code: owner})),
];

const getOwnerLabels = (owner: ProductOwner, products: Product[]) => {
  const ownerLabel = formatOwner(owner);
  const distributors = products
    .filter(product => product.owner === owner.code && product.distributor)
    .map(product => product.distributor);

  return distributors.length > 0
    ? distributors.map(distributor => `${ownerLabel} / ${distributor}`)
    : [ownerLabel];
};

export const getProductOwnerDistributionLabels = (
  products: Product[],
  productOwners: ProductOwner[],
): string[] => {
  const labels = getAllOwners(products, productOwners)
    .flatMap(owner => getOwnerLabels(owner, products))
    .filter(label => label);

  return [...new Set(labels)];
};
